import {checker} from './checker';

/**
 * Converts an array of letters into a string
 * @param {array} word
 * @return {string} converted string
 */
export function convertToText(word) {
  if (!word || word.length === 0) {
    return '';
  }
  let text = '';
  word.forEach((item) => {
    text += item.val.val;
  });
  return text;
}

/**
 * Checks to see if a string is a valid word.
 * @param {string} text
 * @return {boolean} true if valid
 */
export function isValid(text) {
  if (!text || text.length < 3) {
    return false;
  }
  return checker(text);
}

/**
 * Calculates the score for a word.
 * @param {boolean} isValid indicates if word is valid
 * @param {array} word array of letters
 * @return {number} total score of word
 */
export function score(isValid, word) {
  if (!word || !isValid) {
    return 0;
  }
  let score = 0;
  word.forEach((letter) => {
    score = score + (letter.val.vowel ? 0 : letter.val.score);
  });
  score += (word.length - 3) * 2;
  return score > 0 ? score : 0;
}
